import { Button } from '../../design'
import { useSession } from '../../session/useSession'
import { ChangePasswordForm } from './ChangePasswordForm'
import { PASSWORD_COPY } from './copy'

export const ForcedPasswordChange = () => {
  const session = useSession()
  return (
    <div className="entry sign-in">
      <div className="entry-band hatch" aria-hidden="true" />
      <main className="entry-sheet">
        <h1 className="sign-in-title">{PASSWORD_COPY.forcedTitle}</h1>
        <p className="sign-in-subtitle">{PASSWORD_COPY.forcedBody}</p>
        <div className="sign-in-form">
          <ChangePasswordForm id="forced-password" currentLabel={PASSWORD_COPY.temporary} onChange={session.changePassword} />
        </div>
        <Button variant="ghost" onClick={() => void session.signOut()}>
          {PASSWORD_COPY.signOut}
        </Button>
      </main>
    </div>
  )
}
